export function invitationDeliveryView(data,eventId) {
  const marker=data?.invitationDelivery;
  if(marker?.deliveryMode !== "FREE_WATERMARK" || (marker.watermarked && (data.autopilotAssignment?.packageId || data.rsvpAccess?.classification === "MANUAL")))return data;
  const original=data.invitationData?.attachmentData;
  if(!original?.url || !marker.url)return data;
  return {...data,invitationData:{...data.invitationData,attachmentData:{url:marker.url,fileType:marker.fileType || "image/jpeg"}}};
}
